"use client";

import React, { useState } from 'react';
import AnimatedIcon from '@/components/ui/AnimatedIcon';

interface PillarCardProps {
  title: string;
  icon: string;
  color: string;
  desc: string;
}

export const PillarCard = ({ title, icon, color, desc }: PillarCardProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className="relative group hover:-translate-y-2 transition-all duration-500"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Overlapping Icon Circle - Sibling to the body so it handles overflow correctly */}
      <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-20 h-20 rounded-full bg-bloom-cream border-2 border-bloom-linen flex items-center justify-center shadow-none group-hover:scale-110 group-hover:bg-white transition-all duration-500 z-20">
        <div className="relative">
          <AnimatedIcon 
            name={icon} 
            size={32} 
            color={color} 
            trigger={isHovered ? 'always' : 'none'}
            className="transition-transform"
          />
          <div className="absolute inset-0 bg-bloom-gold/5 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
      </div>

      {/* Actual Card Body - Handles background and clipping for the line */}
      <div className="relative bg-white p-10 pt-16 rounded-[32px] border-2 border-bloom-linen overflow-hidden z-10 h-full text-center">
        <h3 className="font-serif text-2xl font-bold text-bloom-charcoal mb-4 group-hover:text-bloom-green-deep transition-colors">
          {title}
        </h3>
        <p className="font-sans text-bloom-muted leading-relaxed">
          {desc}
        </p>
        
        {/* The accent border is now safely inside an overflow-hidden container */}
        <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-bloom-gold w-0 group-hover:w-full transition-all duration-700" />
      </div>
    </div>
  );
};
